import React, { Component } from 'react';
import i18n from '../../../plugins/i18n/i18n'
import { actions } from '../../../store/modules';
import { connect } from 'react-redux';
import { Result, Button } from 'antd'
import queryString from "query-string";
import { LoadingOutlined } from '@ant-design/icons';


class EmailConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSend: true,
      loading: false,
      isSuccess: false,
      errorMessage: null,
      description: null,
      form: {
        token: null,
        email: null
      }

    }
  }

  componentWillMount() {

    let params = queryString.parse(window.location.search);
    if (params && !params.token) {
      this.props.history.push(
        `/auth/sign-in`
      );
    }
    if (params && !params.email) {
      this.props.history.push(
        `/auth/sign-in`
      );
    }

    let { form } = this.state;
    form.token = decodeURIComponent(params.token);
    form.email = params.email;

    this.setState({ form }, () => {
      this.fetch(form)
    })

  }

  fetch = (values) => {
    this.setState({
      loading: true
    })

    let { form } = this.state;

    var param = {
      email: form.email,
      token: form.token
    }

    this.props.dispatch(actions.auth.confirmEmail(param))
      .then((response) => {

        this.setState({
          isSuccess: true,
          description: response.description,
          isSend: false
        })

      })
      .catch(error => {

        let responseErrorMessage = (error && error.errors && error.errors[0].error && error.errors[0].error) || (error && error.description && error.description) || (i18n.t('unknownErrorOccurred', { lng: this.props.currentLanguage }));

        this.setState(
          {
            loading: false,
            description: responseErrorMessage,
            isSend: false
          },
          () => {
            setTimeout(() => {
            }, 3500);
          })
      })
  }

  fetchLogin = (password) => {

    this.setState({ loading: true })
    let { form } = this.state;

    let _this = this;

    var param = {
      username: form.email,
      password: password
    }

    this.props.dispatch(actions.auth.login(param))
      .then(() => {
        this.props.history.push(
          `/app/home`
        );
      })

      .catch(error => {

        let responseErrorMessage = JSON.parse(JSON.stringify(error)).response.data.error_description;
        this.setState(
          {
            loading: false,
            loginSuccess: false,
            errorMessage: responseErrorMessage
          },
          () => {
            setTimeout(() => {
              _this.setState({ loginSuccess: null });
            }, 3500);
          })
      })
  }


  render() {

    let { isSuccess, description } = this.state;

    return (
      this.state.isSend ?
        <div className="auth-content">
          <div className=''>
            <Result
              title="E-posta adresiniz doğrulanıyor.."
              extra={[
              ]}
              icon={<LoadingOutlined />}
            />
          </div>
        </div>
        :
        <div className="auth-content">
          <div className=''>
            <Result
              status={isSuccess ? `success` : `error`}
              title="E-posta doğrulama"
              subTitle={description}
              extra={[
                <Button
                  key="buy"
                  onClick={() => this.props.history.push(
                    `/auth/sign-in`
                  )}

                >Giriş yap</Button>,
              ]}
            />
          </div>
        </div>

    )
  }
}


const mapStateToProps = ({ auth }) => ({
  ...auth
});
export default connect(mapStateToProps)(EmailConfirm);






// WEBPACK FOOTER //
// ./src/components/Auth/Views/EmailConfirm.js